import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@1trading/react/components/ui/select';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ACTIVITY_BANDS } from '@/constants/institution';
import type { InstitutionExpectedActivityOrDefaults } from '@/features/institution/expected-activity/schema';

const InstitutionExpectedActivityFieldsetIncome = () => {
  const form = useFormContext<InstitutionExpectedActivityOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        name="netAnnualIncome"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.netAnnualIncome')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.expectedActivity.placeholders.netAnnualIncome')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {ACTIVITY_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.expectedActivity.activityBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="expectedAnnualInvestment"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.expectedActivity.expectedAnnualInvestment')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.expectedActivity.placeholders.expectedAnnualInvestment')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {ACTIVITY_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.expectedActivity.activityBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionExpectedActivityFieldsetIncome.displayName = 'InstitutionExpectedActivityFieldsetIncome';

export { InstitutionExpectedActivityFieldsetIncome };
